import React from 'react';

import { Text } from '@reckon-web/text';

import { ActivityTargetValue } from '../activities-types';
import { getTargetType } from '../helper';

interface IActivityCategoryDeleted {
  activityTarget: ActivityTargetValue;
}
// Activity Category Deleted = 5
export const ActivityCategoryDeleted = ({
  activityTarget,
}: IActivityCategoryDeleted) => (
  <Text size="small">Deleted the {getTargetType(activityTarget)}</Text>
);
